export class Config {
    public static host = 'dcb.mm-coaching.net';
    public static path = '/api';
    public static port = '443';
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/config.ts